import { useNavigate } from 'react-router-dom';
import useAppModal from 'hooks/useAppModal';
import { useTranslation } from 'react-i18next';
import CustomTemplateAddEditModal from './CustomTemplateAddEditModal';
import { CUSTOM_TEMPLATE_ADD_EDIT_MODAL_ID } from './CustomTemplateAddEditModal.constants';

const useCustomTemplateAddEditModal = () => {
  const { openModal } = useAppModal();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const onHide = () => {
    navigate('../', { replace: true });
  };

  const openAddCustomTemplateModal = () => {
    openModal({
      id: CUSTOM_TEMPLATE_ADD_EDIT_MODAL_ID,
      customContent: <CustomTemplateAddEditModal closeModal={onHide} />,
      title: t('pageAutomations.customTemplates.modal.addTitle'),
      closeOnHide: false,
      onHide,
    });
  };

  const openEditCustomTemplateModal = ({
    customTemplateUid,
  }: {
    customTemplateUid: string;
  }) => {
    openModal({
      id: CUSTOM_TEMPLATE_ADD_EDIT_MODAL_ID,
      customContent: (
        <CustomTemplateAddEditModal
          customTemplateUid={customTemplateUid}
          closeModal={onHide}
        />
      ),
      title: t('pageAutomations.customTemplates.modal.editTitle'),
      closeOnHide: false,
      onHide,
    });
  };

  return {
    openAddCustomTemplateModal,
    openEditCustomTemplateModal,
  };
};

export default useCustomTemplateAddEditModal;
